import React from 'react'
import { Button } from 'antd'
import './index.css'

interface ButtonDangerProps {
  buttonText?: string;
  loading?: boolean;
  htmlType?: 'submit' | 'button' | 'reset';
  onClick?: () => void;
}

const ButtonDanger: React.FC<ButtonDangerProps> = ({
  buttonText = 'Submit',
  loading = false,
  htmlType = 'submit',
  onClick = () => {},
}) => {
  return (
    <div className="button-holder-danger">
      <Button type="primary" htmlType={htmlType} onClick={onClick} loading={loading}>
        {buttonText}
      </Button>
    </div>
  )
}

export default ButtonDanger
